{
  "app": {
    "name": "Fermin Marker",
    "brand": "FERMIN"
  },
  "buttons": {
    "activate": "ACTIVAR",
    "retry": "Reintentar",
    "reconfigure": "Configurar de nuevo",
    "home": "Volver al inicio"
  },
  "states": {
    "loading": "Cargando…",
    "processing": "Procesando…",
    "connecting": "Conectando…",
    "activating": "Activando…",
    "reconnecting": "Estamos intentando reconectar…"
  },
  "codeInput": {
    "label": "Código de activación",
    "cell": "Carácter {index} de {total}",
    "help": "Seis letras o números, sin 0, O, 1 ni I."
  },
  "clock": {
    "label": "Hora de la sede"
  },
  "status": {
    "connecting": "Conectando…",
    "online": "Conectado",
    "offline": "Sin conexión",
    "autonomous": "Modo sin conexión",
    "paused": "Marcador en pausa",
    "disabled": "Marcador deshabilitado"
  },
  "kiosk": {
    "wakeLockUnsupported": "Desactiva el bloqueo automático de pantalla",
    "fullscreenHint": "Toca la pantalla para volver a pantalla completa"
  },
  "notFound": {
    "title": "Pantalla no encontrada",
    "description": "Esta dirección no existe en el marcador.",
    "action": "Volver al inicio"
  },
  "errors": {
    "VALIDATION_ERROR": "Revisa el código ingresado.",
    "UNAUTHENTICATED": "Este marcador ya no tiene sesión. Vuelve a configurarlo.",
    "FORBIDDEN": "Esta pantalla no tiene permiso para hacer esto.",
    "NOT_FOUND": "No encontramos lo que buscas.",
    "CONFLICT": "La acción no se pudo completar. Inténtalo de nuevo.",
    "READ_ONLY": "El servicio está en modo de solo lectura. Contacta a tu empresa.",
    "RATE_LIMITED": "Demasiados intentos. Espera un momento",
    "INTERNAL_ERROR": "Ocurrió un error inesperado. Inténtalo nuevamente.",
    "NETWORK": "Sin conexión. Revisa la red de la sede e inténtalo de nuevo.",
    "COMPANY_SUSPENDED": "El servicio está suspendido. Contacta a tu empresa.",
    "TERMINAL_CODE_INVALID": "Código no válido o vencido",
    "TERMINAL_SESSION_REVOKED": "Este marcador fue desvinculado. Vuelve a configurarlo."
  }
}
